

<!-- <mat-toolbar class="primary">
    <div *ngIf="show">fdcfdfd</div>
    <button (click)="toggle()" class="navbar-toggler navbar-toggler-custom">
        <span class="navbar-toggler-icon"></span>
      </button>
    
  <span><img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid" style="height: 40px;"></span>
  <span class="headerSpace"></span>
  <span>
    <p *ngIf="this.helper.accountLoaded">Account : {{this.helper.accountList[this.helper.slectedAddress]}}</p>
  </span>

</mat-toolbar> -->
<div class="rootCard">
  <router-outlet></router-outlet>
</div>

